
export class CustomerIndividualMedicalAlert {
    public id: number;
    public customerNumberID: number;
    public customerIndividualMedicalAlertTypeId: number;
    public effectiveDate: any;
    public endDate: any;
    public confirmAdminAction: boolean;

    public inactivate: boolean;
    public updatedBy: string;
    public updatedDate: any;

    public viewId: number;
    public alertType: string;
}
